import { useState } from "react";
import { apiURL } from "../../consts/URLs";
import { MODELS } from "../endpointList";
import { fetchRequest, getOptions } from "../utils";
import { getCookie } from "../../utils/handleCookie";
import { cookieName } from "../../consts/cookie";

const token = getCookie(cookieName.token);

const useModels = () => {
  const [createResponse, setCreateResponse] = useState<any>();
  const [createResult, setCreateResult] = useState<any>();
  const [updateResponse, setUpdateResponse] = useState<any>();
  const [updateResult, setUpdateResult] = useState<any>();
  const [deleteResponse, setDeleteResponse] = useState<any>();
  const [deleteResult, setDeleteResult] = useState<any>();
  const [getByIdResponse, setGetByIdResponse] = useState<any>();
  const [getByIdResult, setGetByIdResult] = useState<any>();

  const [getModelsListPaginatedResponse, setGetModelsListPaginatedResponse] =
    useState<any>();
  const [getModelsListPaginatedResult, setGetModelsListPaginatedResult] =
    useState<any>();
  const [getModelsListAllResponse, setGetModelsListAllResponse] =
    useState<any>();
  const [getModelsListAllResult, setGetModelsListAllResult] = useState<any>();

  const createModels = (obj: any) => {
    const url = `${apiURL}/${MODELS}`;
    const options = getOptions({
      method: "POST",
      body: {
        ...obj,
      },
      token: token,
    });
    fetchRequest(url, options, setCreateResponse, setCreateResult);
  };

  const updateModels = (id: number, obj: any) => {
    const url = `${apiURL}/${MODELS}/${id}`;
    const options = getOptions({
      method: "PUT",
      body: { ...obj },
      token: token,
    });
    fetchRequest(url, options, setUpdateResponse, setUpdateResult);
  };

  const deleteModels = (id: number) => {
    const url = `${apiURL}/${MODELS}/${id}`;
    const options = getOptions({ method: "DELETE", token: token });
    fetchRequest(url, options, setDeleteResponse, setDeleteResult);
  };

  const getModelById = (id: number) => {
    const url = `${apiURL}/${MODELS}/${id}`;
    const options = getOptions({ method: "GET", token: token });
    fetchRequest(url, options, setGetByIdResponse, setGetByIdResult);
  };

  const getModelsListPaginated = () => {
    const url = `${apiURL}/${MODELS}`;
    const options = getOptions({ method: "GET", token: token });
    fetchRequest(
      url,
      options,
      setGetModelsListPaginatedResponse,
      setGetModelsListPaginatedResult
    );
  };

  const getModelsListAll = () => {
    const url = `${apiURL}/${MODELS}/all`;
    const options = getOptions({ method: "GET", token: token });
    fetchRequest(
      url,
      options,
      setGetModelsListAllResponse,
      setGetModelsListAllResult
    );
  };

  const RESPONSES = {
    createResponse,
    updateResponse,
    deleteResponse,
    getByIdResponse,
    getModelsListPaginatedResponse,
    getModelsListAllResponse,
  };

  const RESULTS = {
    createResult,
    updateResult,
    deleteResult,
    getByIdResult,
    getModelsListPaginatedResult,
    getModelsListAllResult,
  };

  const CTAs = {
    createModels,
    updateModels,
    deleteModels,
    getModelById,
    getModelsListPaginated,
    getModelsListAll,
  };

  return { RESPONSES, RESULTS, CTAs };
};
export default useModels;
